import React from 'react';
import { Container } from 'reactstrap';
import { uniqueId } from 'lodash';
import SkeletonElement from '../../../../components/skeletons/SkeletonElement';

const ARTICLES_COUNT = 4;

const PaymentResultSkeleton = () => {
  const quantitiesPreview = [...Array(ARTICLES_COUNT)].map(() => (
    <div key={uniqueId()}>
      <div className="d-flex justify-content-between">
        <SkeletonElement type="label" />
        <SkeletonElement type="label-short" />
      </div>
      <hr />
    </div>
  ));

  return (
    <Container className="payment-result-container">
      <div className="my-4">
        <SkeletonElement type="button" className="w-25 mx-auto mb-4" />
        <SkeletonElement type="label" className="mx-auto" />
      </div>
      <div>
        <SkeletonElement type="label-short" className="text-start mb-4" />
        {quantitiesPreview}
      </div>
      <div>
        <SkeletonElement type="label" className="mb-3" />
        <SkeletonElement type="label" className="mb-3" />
      </div>
      <div className="my-4">
        <SkeletonElement type="button" className="mb-2" />
        <SkeletonElement type="button" className="mb-2" />
      </div>
    </Container>
  );
};

export default PaymentResultSkeleton;
